import {
  Box,
  Link,
  SimpleGrid,
  SimpleGridProps,
  Stack,
} from "@chakra-ui/react";
import * as React from "react";
import { FooterHeading } from "./FooterHeading";
import { Link as ReachLink } from "react-router-dom";

export const LinkGrid = (props: SimpleGridProps) => (
  <SimpleGrid columns={2} {...props}>
    <Box minW="130px">
      <FooterHeading mb="4" color="white">
        Product
      </FooterHeading>
      <Stack>
        <Link
          as={ReachLink}
          to="/"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          How it works
        </Link>
        <Link
          as={ReachLink}
          to="/"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          Browse all
        </Link>
        <Link
          as={ReachLink}
          to="/"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          Use Cases
        </Link>
      </Stack>
    </Box>
    <Box minW="130px">
      <FooterHeading mb="4" color="white">
        Legal
      </FooterHeading>
      <Stack>
        <Link
          as={ReachLink}
          to="/"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          Privacy
        </Link>
        <Link
          as={ReachLink}
          to="/"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          Terms
        </Link>
        <Link
          as={ReachLink}
          to="/contact-us"
          _hover={{
            textDecoration: "none",
            color: "lightblue",
          }}
          _focus={{
            outline: "none",
            boxShadow: "none",
            textDecor: "none",
          }}
        >
          Contact Us
        </Link>
      </Stack>
    </Box>
  </SimpleGrid>
);
